export default {
  title: 'Modo Móvil No Soportado',
  message: 'Actualmente, la aplicación Astrochingolo está optimizada únicamente para dispositivos de escritorio. La versión móvil se encuentra en desarrollo.',
  message2: 'Para una mejor experiencia, te recomendamos acceder desde una computadora o dispositivo con pantalla más grande.',
  button: 'Entendido'
}
